import times from 'lodash/times';
import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { PDFSafeTableHeaderCaption } from '../../../../CommonComponents/OPL/HtmlTable/components/PDFSafeTableHeaderCaption/PDFSafeTableHeaderCaption';
import { HtmlTable } from '../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';
import { ColumnHeader } from '../../OtherAssets.meta';

export interface Props {
  title: string;
  isEmpty: boolean;
  columnHeaders: ColumnHeader[];
  children: React.ReactNode;
  workflowProps?: WorkflowComponentProps;
}

export const AssetsTable = ({
  title,
  isEmpty,
  columnHeaders,
  children,
  workflowProps,
  ...rest
}: Props) => {
  if (isEmpty) {
    return (
      <HtmlTable variant={workflowProps && 'bordered'} {...rest}>
        <Box p="16">
          <Text variant="cardTitle" color="neutral.700" pb="16">
            {title}
          </Text>

          <Text fontWeight={500} color="neutral.500">
            You have not added any items.
          </Text>
        </Box>
      </HtmlTable>
    );
  }

  return (
    <HtmlTable variant={workflowProps && 'bordered'} {...rest}>
      <table style={{ tableLayout: 'fixed' }}>
        <colgroup>
          {times(columnHeaders.length).map(key => (
            <col key={key} />
          ))}

          <col style={{ width: 126 }} />
        </colgroup>

        <thead>
          <PDFSafeTableHeaderCaption colSpan={columnHeaders.length + 1}>
            {title}
          </PDFSafeTableHeaderCaption>

          <tr>
            {columnHeaders.map(({ text, align }, index) => (
              <th key={text || `column-${index}`} aria-label={text || 'Empty column'}>
                <Text
                  variant="smallCaps"
                  textAlign={align || 'left'}
                  style={{ whiteSpace: 'normal' }}
                >
                  {text}
                </Text>
              </th>
            ))}

            <th aria-label={`${title} Actions`}>&nbsp;</th>
          </tr>
        </thead>

        <tbody>{children}</tbody>
      </table>
    </HtmlTable>
  );
};
